import { render } from "./pageAchieve.vue?vue&type=template&id=e8a75b76&scoped=true"
import script from "./pageAchieve.vue?vue&type=script&lang=js"
export * from "./pageAchieve.vue?vue&type=script&lang=js"

import "./pageAchieve.vue?vue&type=style&index=0&id=e8a75b76&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a75b76"]])

export default __exports__